import { useState, useEffect, useContext } from "react";
import { Link, Navigate } from "react-router-dom";
import axios from "axios";

import { Dropdown, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCopy,
  faEdit,
  faEllipsisV,
  faEye,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

import { DashboardLayout } from "../../Layout/DashboardLayout";

import CustomTable from "../../Components/CustomTable";
import { placeholderImage } from "../../Assets/images";

import "./style.css";
import { questionModal, successModal } from "../../Components/CustomModal";
import CustomFilters from "../../Components/CustomFilters";
import BASEURL from "../../Config/global";
import CustomPagination from "../../Components/CustomPagination";
import CustomLoader from "../../Components/CustomLoader";
import { disabledButtonByPermission } from "../../Components/Permissions";
import { PermissionsContext } from "../../Layout/PermissionContext";
import moment from "moment";
import { deleteRequest } from "../../Util/requests";
import CustomInput from "../../Components/CustomInput";
import { getAccessToken } from "../../Util/token";

const CouponManagement = () => {
  const [data, setData] = useState([]);
  const { permissions } = useContext(PermissionsContext)
  const [swapInputError, setInputError] = useState({ error: true, text: '' });
  const [showSwapModal, setShowSwapModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [enteries, setEnteries] = useState(10);
  const [offset, setOffset] = useState(0);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [filterSearchValue, setFilterSearchValue] = useState("");
  const [sort, setSort] = useState("all");
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedLanguage, setSelectedLanguage] = useState("english");


  useEffect(() => {
    if (currentPage != undefined) {
      setOffset(currentPage);
    }
  }, [currentPage])

  const modulesWisePermission = (condition) => {
    if (!permissions) {
      return 'd-none'
    }
    return disabledButtonByPermission(permissions, condition)
  }
  useEffect(() => {
    document.title = "Relax Scofa | Promo Management";
  }, []);

  useEffect(() => {
    fetchData();
  }, [enteries, dateTo, filterSearchValue, offset, selectedLanguage]);

  async function fetchData() {
    try {
      const languageParam = selectedLanguage === "spanish" ? "&language=spanish" : "";
      const response = await axios.get(
        `${BASEURL}/api/user/coupon?limit=${enteries}&offset=${offset}&start_date=${dateFrom}&end_date=${dateTo}&search=${filterSearchValue}${languageParam}`
      );
      if (response.data.error != true) {
        console.log(response.data.data);
        setData(response.data.data);
        setTotalCount(response.data.count);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  }

  // useEffect(() => {
  //   if (filterSearchValue.length > 0) {
  //     const filteredData = data.filter((item) => item.title.toLowerCase().includes(filterSearchValue));
  //     setData(filteredData)
  //   } else {
  //     fetchData();
  //   }
  // }, [filterSearchValue]);

  const deleteArticle = async (id) => {

    questionModal
      .fire({
        title: `Do you want to delete Promo?`,
        confirmButtonText: "Yes",
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteArticleAction(id);
        }
      });



  };

  const deleteArticleAction = async (id) => {
    setLoader(true);

    try {
      const response = await deleteRequest(`/api/user/coupon/${id}/`);
      if (response.data.error === false) {
        successModal.fire({
          text: "Promo Deleted Successfully",
          confirmButtonText: "Continue",
        });
        await fetchData()
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const couponsHeader = [
    {
      key: "id",
      title: "S.No",
    },
    {
      key: "title",
      title: "Title",
    },
    {
      key: "tag",
      title: "tag",
    },
    {
      key: "primary_user_count",
      title: "Prm Cnt",
    },
    {
      key: "household_user_count",
      title: "Hshld Cnt",
    },
    {
      key: "expires",
      title: "Expires",
    },
    {
      key: "code",
      title: "Code",
    },
    {
      key: "allowed_uses",
      title: "Alwd Uses",
    },
    {
      key: "current_uses",
      title: "Used",
    },
    {
      key: "price",
      title: "Price",
    },
    {
      key: "trialperiod",
      title: "Trial",
    },
    {
      key: "termsindays",
      title: "Term",
    },
    {
      key: "subscriptiontype",
      title: "Sub Type",
    },
    {
      key: "actions",
      title: "Actions",
    },
  ];

  const sortingValues = [
    {
      value: "all",
      text: "All",
    },
    {
      value: "status",
      text: "Status",
    },
    {
      value: "registered",
      text: "Registered Date",
    },
  ];

  const handleChangeEntries = (no) => {
    setOffset(0)
    setEnteries(no)
  }
  const updateOrAddCategory = async () => {
    const { mtag, code } = formData;
    if (!mtag || !code || mtag.trim() === "" || code.trim() === "") {
      setInputError({ error: true, text: 'Please fill all fields' });
      return;
    }
    questionModal
      .fire({
        title: `Do you want to duplicate this promo details?`,
        confirmButtonText: "Duplicate",
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          await postData().then(async (response) => {
            const { status, message } = response.data
            if (status === 500) {
              setInputError({ error: true, text: message });
              setLoader(false)
              return null;
            } else {
              setShowSwapModal(false);
              setFormData({});
              setInputError({ error: false, text: '' });
              successModal.fire({
                text: "Promo details Duplicated successfully",
                confirmButtonText: "Continue",
              });
              await fetchData()
              setLoader(false);
            }
          }).catch(error => {
            setLoader(false);
            console.log("error", error)
          });

        }
      });
  };
  const postData = async () => {
    try {
      setLoader(true);
      const body = {
        "title": formData.title,
        "description": formData.description,
        "code_description": formData.code_description,
        "code": formData.code,
        "price": Number(formData.price),
        "expiry_date": formData.is_expiry_unlimited ? null : formData.expiry_date,
        "is_expiry_unlimited": formData.is_expiry_unlimited,
        "subscription_type": formData.subscription_type,
        "duration_type": formData.duration_type,
        "mtag": formData.mtag,
        "active_status": formData.active_status,
        "trial_period": Number(formData.trial_period),
        "term_in_days": Number(formData.term_in_days),
        "number_of_uses_allowed": Number(formData.number_of_uses_allowed),
        "primary_promo_user": Number(formData?.primary_promo_user?.id),
        "household_promo_user": Number(formData?.household_promo_user?.id),
        "is_propagation_allowed": formData.is_propagation_allowed,
        "propagation_title": formData.propagation_title,
        "propagation_description": formData.propagation_description,
        "propagation_code_description": formData.propagation_code_description,
        "propagation_code": formData.propagation_code,
        "propagation_price": Number(formData.propagation_price),
        "propagation_expiry_date": formData.propagation_is_expiry_unlimited ? null : formData.propagation_expiry_date,
        "propagation_is_expiry_unlimited": formData.propagation_is_expiry_unlimited,
        "propagation_subscription_type": formData.propagation_subscription_type,
        "propagation_duration_type": formData.propagation_duration_type,
        "propagation_trial_period": Number(formData.propagation_trial_period),
        "propagation_term_in_days": Number(formData.propagation_term_in_days),
        "propagation_primary_promo_user": Number(formData?.propagation_primary_promo_user?.id),
        "propagation_household_promo_user": Number(formData?.propagation_household_promo_user?.id),
        "promo_asset": formData?.promo_asset?.id,
        "promo_propagation_asset": formData?.promo_propagation_asset?.id,
        "propagation_is_propagation_allowed": formData?.propagation_is_propagation_allowed,
        "countries": formData?.countries,
        "primary_promo_user_es": Number(formData?.primary_promo_user_es?.id),
        "household_promo_user_es": Number(formData?.household_promo_user_es?.id),
        "propagation_primary_promo_user_es": Number(formData?.propagation_primary_promo_user_es?.id),
        "propagation_household_promo_user_es": Number(formData?.propagation_household_promo_user_es?.id),
      }
      const token = getAccessToken();
      const URL = `${BASEURL}/api/user/coupon`
      const response = await axios.post(URL, body, {
        headers: {
          'Authorization': 'Token ' + token
        }
      });
      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
    setInputError({ error: false, text: '' })

  };

  const handleDuplicateAction = async (oldPromoId) => {
    await getDataByApi(oldPromoId)
    setShowSwapModal(true)
    setInputError({ error: false, text: '' })
  }

  const getDataByApi = async (id) => {
    try {
      const response = await axios.get(`${BASEURL}/api/user/coupon/${id}/`);
      if (!response?.data?.error) {
        let obj = response?.data?.data;
        let propagatedObj = response?.data?.data?.propated_coupon_details;
        obj = { ...obj, ...propagatedObj, code: "", mtag: "" }
        setFormData(obj);
      }
    } catch (error) {
      console.error(error);
    }
  }
  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-lg-8 mb-2">
              <h2 className="mainTitle">Promos </h2>
            </div>
            <div className="col-lg-4 text-end mb-2">
              <Link
                to={"/promo-management/add-promo"}
                className={`customButton primaryButton ${modulesWisePermission('can_add')}`}
              >
                Add Promo
              </Link>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12">
              <CustomFilters
                enteries={enteries}
                totalCount={totalCount}
                entriesFilter={true}
                setEnteries={handleChangeEntries}
                filterSearch={true}
                filterSearchValue={filterSearchValue}
                setFilterSearchValue={setFilterSearchValue}
                // dateFilter={true}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                // languageFilter
                // languageValue={selectedLanguage}
                // setLanguageValue={setSelectedLanguage}
              // isSearchDropdown={couponsHeader}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12">
              <CustomTable headers={couponsHeader}>
                <tbody>
                  {data &&
                    data.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.title}</td>
                        <td>{item.mtag}</td>
                        <td>{item.primary_user_count}</td>
                        <td>{item.house_hold_user_count}</td>
                        <td>{(item.expiry_date === "undefined" || item.expiry_date === null) ? "Unlimited" : moment(item.expiry_date).format('MM-DD-YYYY')}</td>
                        <td className="text-uppercase">{item.code}</td>
                        {/* allowed uses */}
                        <td>{Number(item?.number_of_uses_allowed) > 0 ? item?.number_of_uses_allowed : 'Unlimited'}</td>
                        {/* current uses */}
                        <td>
                          {
                            item?.current_uses && <Link
                              to={`/reportings/promo/${item.id}`}
                              // className={`tableAction`}
                              style={{ textDecoration: 'none', color: 'white' }}
                              target="_blank"
                            >
                              {item?.current_uses}
                            </Link>
                          }
                        </td>
                        <td>USD {item.price}</td>
                        <td>{(!item.trial_period || item.trial_period === 'undefined' || Number(item.trial_period) === 0) ? '-' : item.trial_period}</td>
                        <td>{!item.term_in_days || item.term_in_days === 'undefined' || Number(item.term_in_days) === 0 ? '-' : item.term_in_days}</td>
                        <td>{`${item.subscription_type}ly`}</td>
                        <td>
                          <Dropdown className="tableDropdown">
                            <Dropdown.Toggle
                              variant="transparent"
                              className="notButton classicToggle"
                            >
                              <FontAwesomeIcon icon={faEllipsisV} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              align="end"
                              className="tableDropdownMenu"
                            >
                              <Link
                                to={`/promo-management/edit-promo/${item.id}`}
                                className={`tableAction ${modulesWisePermission('can_edit')}`}
                              >
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  className="tableActionIcon"
                                />
                                Edit
                              </Link>
                              <Link
                                to={`/promo-management/promo-detail/${item.id}`}
                                className={`tableAction ${modulesWisePermission('can_view')}`}
                              >
                                <FontAwesomeIcon
                                  icon={faEye}
                                  className="tableActionIcon"
                                />
                                View
                              </Link>
                              <button
                                className={`tableAction`}
                                onClick={() => handleDuplicateAction(item.id)}
                              >
                                <FontAwesomeIcon
                                  icon={faCopy}
                                  className="tableActionIcon"
                                />
                                Duplicate
                              </button>
                              {
                                Number(item?.current_uses) > 0 ? null : <button
                                  className={`tableAction ${modulesWisePermission('can_delete')}`}
                                  onClick={() => {
                                    deleteArticle(item.id, item.title);
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    className="tableActionIcon"
                                  />
                                  Delete
                                </button>
                              }
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </CustomTable>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12">
              <CustomPagination
                enteries={enteries}
                totalCount={totalCount}
                setCurrentPage={setOffset}
                currentPage={offset}
              />
            </div>
          </div>
        </div>
      </DashboardLayout>
      {loader && <CustomLoader />}
      {
        loader ? null : <Modal
          show={showSwapModal}
          centered
          className="swap-modal"
          backdrop="static"
        >
          <Modal.Body>
            <div className="pb-5 w-100 d-flex flex-column align-items-center">
              <div className="d-flex justify-content-between w-100  ">
                <h2 className="mainTitle"> Duplicate Promo Details</h2>
                <div className="text-end ms-auto">
                  <button
                    className="closeButton notButton ms-auto"
                    onClick={() => {
                      setShowSwapModal(false)
                      setInputError({ error: false, text: '' })
                      setFormData({})
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faTimes}
                      className="cross-icon"
                      color="white"
                    />
                  </button>
                </div>
              </div>
              <br />


              <div className='row w-100'>
                <div className="col-12">
                  <CustomInput
                    label="Tag"
                    labelClass="mainLabel"
                    type="text"
                    required
                    name="mtag"
                    value={formData?.mtag || ""}
                    placeholder="Enter Tag"
                    inputClass="mainInput"
                    onChange={handleChange}
                  />

                </div>
              </div>
              <div className="row w-100 mb-3">
                <div className='col-12 mt-auto '>
                  <CustomInput
                    label="Code"
                    labelClass="mainLabel"
                    required
                    type="text"
                    name="code"
                    value={formData?.code || ""}
                    placeholder="Enter Code"
                    inputClass="mainInput"
                    onChange={handleChange}
                  />
                </div>
              </div>


              {swapInputError?.error && <small className="text-danger">{swapInputError.text}</small>}
              <div className=" pt-5 d-flex gap-3 justify-content-center">
                <button style={{ backgroundColor: '#ffffff1f' }} className='px-5 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0' onClick={updateOrAddCategory}>
                  <span className=''>{"Duplicate"}</span>
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      }
    </>
  );
};
export default CouponManagement;
